import { allUserGroupingData } from "../Constants/QRCodeIdByGuideType";

export const setQrCodeIdDataByGuideType = (qrCodeId) => {

    return {
        type: allUserGroupingData.GET_AllUserGroupingData,
        payload: qrCodeId
    };
};